export default __webpack_public_path__ + "static/media/Close_small.059932a4.svg";